import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BillData, PlansData } from "../../common/classes";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: 'app-plan-review-box',
  templateUrl: './plan-review-box.component.html',
  styleUrls: ['./plan-review-box.component.scss']
})
export class PlanReviewBoxComponent implements OnInit {
  @Output() selectPlanMethod: EventEmitter<PlansData> = new EventEmitter();
  @Output() changePlanMethod: EventEmitter<PlansData> = new EventEmitter();
  @Output() cancelPlanMethod: EventEmitter<PlansData> = new EventEmitter();
  @Input() planData: PlansData;
  @Input() billData: BillData;
  @Input() disableButtons: boolean;
  @Input() selectMode: boolean;
  @Input() reviewMode: boolean;
  @Input() manageMode: boolean;
  public today: string;
  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute
  ) {
  }

  ngOnInit(): void {
    const today = new Date();
    const options: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: 'short',
      day: '2-digit'
    };
    this.today =`Today, ${today.toLocaleDateString('en-US', options)}`;
  }

  public onChangePlanMethod() {
    this.changePlanMethod.emit()
  }

  public onCancelPlanMethod() {
    this.router.navigate(['cancel', 'cancel-plan'], { skipLocationChange: true })
  }

  public onSelectPlanMethod() {
    console.log('PlanReviewBoxComponent.onSelectPlanMethod');
    // this.selectPlanMethod.emit(this.data)
  }
}
